import useChangePassword from './useChangePassword';

export default useChangePassword;
